export const TRAILERS = "TRAILERS";
export const EQUIPMENTS = "EQUIPMENTS";
export const TRAILERS_COUNT = "TRAILERS_COUNT";
// export const SELCTED_EQUIPMENT = "SELCTED_EQUIPMENT";
export const APP_TRAILERS_BUSY = "APP_TRAILERS_BUSY";
export const TRAILERS_PAGINATION = "TRAILERS_PAGINATION";
export const EQUIPMENTS_ASSET_TYPE = "EQUIPMENTS_ASSET_TYPE";
